import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { EmptySateIcon } from './icons/empty-state-icon';
import { Button } from './ui';
export var JobsEmptyState = function () {
    return (_jsxs("div", { className: 'w-full h-full flex flex-col justify-center text-vjwPrimary items-center gap-2 py-8 bg-cardBackground rounded-lg', children: [_jsx(EmptySateIcon, {}), _jsx(Button, { type: 'button', children: "Refresh" })] }));
};
